import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function MoveOutChecklist({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Hearing Won-creates move out checklist" />
          </Col>
          <Col span={24}>
            <p className="green-info-text">
              If you do not complete this step and check it off you will not be
              reminded to complete a move out. be sure to check off once
              completed !!!
            </p>
          </Col>
          <Col span={24}>
            <h2 className="red-info-heading">
              After hearing the eviction you must do the following if the tenant
              wants to pay what is owed.
            </h2>
          </Col>
          <Col span={24}>
            <h2 className="red-info-heading">
              1. get approval from the property owner before accepting the
              payment
            </h2>
          </Col>
          <Col span={24}>
            <h2 className="red-info-heading">
              2. notify the broker to dismiss the eviction if the owner decides
              to accept the payment.
            </h2>
          </Col>
          <Col span={24}>
            <h2 className="red-info-heading">
              3. remove evict tag from tenants page
            </h2>
          </Col>
          <Col span={24}>
            <p className="red-info-heading">
              send someone to check and see if the home is vacant if vacant if
              you are not able to drive by check with other PM's and Gina for a
              drive by to see if vacant.
            </p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" onClick={handleComplete} disabled={isDisabled}>Complete</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default MoveOutChecklist;
